<template>
  <v-dialog v-model="modalVisibility" hide-overlay fullscreen>
    <v-card>
      <v-flex>

        <v-toolbar dark color="primary">
          <v-btn icon dark @click="$emit('onClose')">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="$emit('onSave')">Salvar</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container fluid grid-list-md fill-height>

          <v-layout
            justify-center>
            <v-flex xs12 sm6 md6 mt-4>
              <!-- Slot default para componentes de form -->
              <slot v-if="modalVisibility"></slot>
            </v-flex>
          </v-layout>

        </v-container>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>

/**
 * @vuese
 * Componente responsável pela edição/criação com uso de forms
 */
export default {
  name: 'ModalForm',

  props: {
    // Controla visibilidade da modal
    visibility: {
      type: Boolean,
      required: true
    },

    // Atributos do responsavel
    title: {
      type: String,
      required: true
    }
  },

  computed: {
    modalVisibility: {
      get () {
        return this.visibility
      },

      set () {
        this.$emit('onClose')
      }
    }
  }
}
</script>
